import { render, staticRenderFns } from "./StepChooseOrganizationNameComponent.vue?vue&type=template&id=1c838436&scoped=true&"
import script from "./StepChooseOrganizationNameComponent.vue?vue&type=script&lang=js&"
export * from "./StepChooseOrganizationNameComponent.vue?vue&type=script&lang=js&"
import style0 from "./StepChooseOrganizationNameComponent.vue?vue&type=style&index=0&id=1c838436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c838436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VExpandTransition,VFlex,VIcon,VLayout,VTextField})
